import { $t } from '../i18n'
import type { APIResponse } from './APIClient'
import type { BaseAPIError } from './error/BaseAPIError'
import { ApplicationAPIError } from './error/ApplicationAPIError'
import { ApplicationValidationAPIError } from './error/ApplicationValidationAPIError'
import { ConflictAPIError } from './error/ConflictAPIError'
import { InvalidRequestAPIError } from './error/InvalidRequestAPIError'
import { NotAccessibleAPIError } from './error/NotAccessibleAPIError'
import { ServerAPIError } from './error/ServerAPIError'
import { UnAuthorizationAPIError } from './error/UnAuthorizationAPIError'
import { UnhandledAPIError } from './error/UnhandledAPIError'

export const toAPIError = (status: number, responseData: APIResponse<unknown>): BaseAPIError => {
  const message = responseData.message ?? $t('An unexpected error has occurred.')

  switch (status) {
    case 200:
      if (responseData.validationErrors && responseData.validationErrors.length > 0) {
        return new ApplicationValidationAPIError(responseData.validationErrors)
      }

      return new ApplicationAPIError(message)

    case 400:
    case 422:
      return new InvalidRequestAPIError(message)

    case 401:
      return new UnAuthorizationAPIError(message)

    case 403:
      return new NotAccessibleAPIError(message)

    case 409:
      return new ConflictAPIError()

    case 500:
      return new ServerAPIError(message)

    default:
      return new UnhandledAPIError()
  }
}
